// Resize poller
(function ($) {
  let resizeTimeout = null;

  $(window).resize(function () {
    if(resizeTimeout) {
      clearTimeout(resizeTimeout);
    }

    resizeTimeout = setTimeout(() => {
      $('body').trigger('resizeEvent');
    }, 100); // Only check resize every 100ms
  });
})(jQuery);